const Placeholder = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 305 263">
    <rect width="305" height="263" fill="#f9f9f9"/>
  </svg>
);
export default Placeholder;
